function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { runEngine } from "../../../framework/src/RunEngine";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");
export default class OTPInputAuthController extends BlockComponent {
  // Customizable Area End

  constructor(props) {
    super(props);
    // Customizable Area Start
    _defineProperty(this, "submitButtonColor", configJSON.submitButtonColor);
    _defineProperty(this, "btnSubmitOTPProps", {
      onPress: () => this.submitOtp()
    });
    _defineProperty(this, "txtMobilePhoneOTPWebProps", {
      onChangeText: text => this.setState({
        otp: text
      })
    });
    _defineProperty(this, "txtMobilePhoneOTPMobileProps", _objectSpread(_objectSpread({}, this.txtMobilePhoneOTPWebProps), {}, {
      keyboardType: "numeric"
    }));
    _defineProperty(this, "txtMobilePhoneOTPProps", this.isPlatformWeb() ? this.txtMobilePhoneOTPWebProps : this.txtMobilePhoneOTPMobileProps);
    this.subScribedMessages = [
    // Customizable Area Start
    getName(MessageEnum.RestAPIResponceMessage), getName(MessageEnum.NavigationPayLoadMessage)
    // Customizable Area End
    ];
    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this, this.subScribedMessages);

    // Customizable Area Start
    this.state = {
      otp: "",
      otpAuthToken: "",
      userAccountID: "",
      labelInfo: configJSON.labelInfo,
      toMessage: "",
      isFromForgotPassword: false
    };
    this.btnTxtSubmitOtp = configJSON.btnTxtSubmitOtp;
    this.placeHolderOtp = configJSON.placeHolderOtp;
    // Customizable Area End
  }
  async receive(from, message) {
    // Customizable Area Start
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id && this.otpAuthApiCallId != null && this.otpAuthApiCallId === message.getData(getName(MessageEnum.RestAPIResponceDataMessage))) {
      var responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));
      if (responseJson && (responseJson.messages || responseJson.meta && responseJson.meta.token)) {
        if (responseJson.meta && responseJson.meta.token) {
          this.setState({
            otpAuthToken: responseJson.meta.token
          });
        }
        if (this.state.isFromForgotPassword) {
          // runEngine.debugLog("about to send NavigationNewPasswordMessage");
          const msg = new Message(getName(MessageEnum.NavigationNewPasswordMessage));
          msg.addData(getName(MessageEnum.AuthTokenDataMessage), this.state.otpAuthToken);
          msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
          this.send(msg);
        } else {
          const msg = new Message(getName(MessageEnum.NavigationMobilePhoneAdditionalDetailsMessage));
          msg.addData(getName(MessageEnum.AuthTokenDataMessage), this.state.otpAuthToken);
          msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
          this.send(msg);
        }
      } else {
        //Check Error Response
        this.parseApiErrorResponse(responseJson);
      }
      var errorReponse = message.getData(getName(MessageEnum.RestAPIResponceErrorMessage));
      if (errorReponse != null) {
        this.parseApiCatchErrorResponse(errorReponse);
      }
    } else if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
      const phoneAuthToken = message.getData(getName(MessageEnum.AuthTokenDataMessage));
      const phoneNumber = message.getData(getName(MessageEnum.AuthTokenPhoneNumberMessage));
      const forgotPasswordBool = message.getData(getName(MessageEnum.EnterOTPAsForgotPasswordMessage));
      const emailValue = message.getData(getName(MessageEnum.AuthTokenEmailMessage));
      const userAccountID = phoneNumber ? "" + phoneNumber : "" + emailValue;
      let updatedLabel = this.state.labelInfo;
      if (userAccountID && userAccountID !== "undefined") {
        updatedLabel = updatedLabel.replace("phone", userAccountID);
      }
      this.setState({
        otpAuthToken: phoneAuthToken && phoneAuthToken.length > 0 ? phoneAuthToken : this.state.otpAuthToken,
        userAccountID: userAccountID,
        labelInfo: updatedLabel,
        isFromForgotPassword: forgotPasswordBool === undefined ? this.state.isFromForgotPassword : forgotPasswordBool
      });
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async submitOtp() {
    if (!this.state.otp || this.state.otp.length === 0) {
      this.showAlert(configJSON.errorTitle, configJSON.errorOtpNotValid);
      return;
    }
    const requestMessage = new Message(getName(MessageEnum.RestAPIRequestMessage));
    if (this.state.isFromForgotPassword) {
      // console.log("entered is from forgot password!");
      const header = {
        "Content-Type": configJSON.apiVerifyOtpContentType
      };

      //GO TO REQUEST STATE
      this.otpAuthApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.apiVerifyForgotPasswordOtpEndPoint);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(header));
      const data = {
        token: this.state.otpAuthToken ? this.state.otpAuthToken : "",
        otp_code: this.state.otp ? this.state.otp : ""
      };
      const httpBody = {
        data: data
      };

      //requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "POST");

      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(httpBody));
    } else {
      const headers = {
        "Content-Type": configJSON.apiVerifyOtpContentType,
        token: this.state.otpAuthToken
      };
      this.otpAuthApiCallId = requestMessage.messageId;
      requestMessage.addData(getName(MessageEnum.RestAPIResponceEndPointMessage), configJSON.apiVerifyOtpEndPoint + this.state.otp);
      requestMessage.addData(getName(MessageEnum.RestAPIRequestHeaderMessage), JSON.stringify(headers));
      requestMessage.addData(getName(MessageEnum.RestAPIRequestBodyMessage), JSON.stringify(JSON.stringify({})));
    }
    requestMessage.addData(getName(MessageEnum.RestAPIRequestMethodMessage), configJSON.apiVerifyOtpMethod);
    // console.log("requestMessage.id is: " + requestMessage.id);
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  // Customizable Area End
}